import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

export const settingsService = {
    getContacts: async () : Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.settingsGetContacts);        
    },
    modifyContact: async (data: {
        id: string,
        name: string;
        surname: string,
        phone: string,
        role: number
    }) : Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.settingsModifyContact, data);        
    },
    deleteContact: async (data: {
        id: string
    }) : Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.settingsDeleteContact, data);        
    },
    createContact: async (data: {
        name: string;
        surname: string,
        email: string,
        phone: string,
        role: number
    }) : Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.settingsCreateContact, data);        
    },
    changeAdmin: async(data: {id: string}) : Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.settingsChangeAdmin, data);       
    },
}